import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterRangeSearchValueObject} from './FilterRangeSearchValueObject.js'

export class FilterKmSearchValueObject extends ValueObject {
  #km

  constructor({km}) {
    super()
    this.#km = km
  }

  static create({km}) {
    return new FilterKmSearchValueObject({km: FilterRangeSearchValueObject.create(km)})
  }

  static createWithDefaultValue({config, km}) {
    const {DEFAULT_KM_SEARCH} = config.get('searchFilters')

    return new FilterKmSearchValueObject({
      km: FilterRangeSearchValueObject.create({
        from: km?.from || DEFAULT_KM_SEARCH.from,
        to: km?.to || DEFAULT_KM_SEARCH.to
      })
    })
  }

  static createQueryParams({config, km}) {
    const {DEFAULT_KM_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterKmSearchValueObject({
      km: {
        from: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.KM].from,
          value: km?.from || DEFAULT_KM_SEARCH.from
        }),
        to: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.KM].to,
          value: km?.to || DEFAULT_KM_SEARCH.to
        })
      }
    })
  }

  get isEmpty() {
    return this.#km.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.#km.from.isEmpty && {...this.#km.from.queryParam}),
      ...(!this.#km.to.isEmpty && {...this.#km.to.queryParam})
    }
  }

  get value() {
    return this.#km.value
  }

  toJSON() {
    return {
      km: this.#km.toJSON()
    }
  }
}
